<div
  class="association-picker"
  [ngClass]="
    showOtherSidePicker ? 'no-form-field-padding' : 'less-form-field-padding'
  "
>
  <div>
    <div class="title">Titel</div>
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        placeholder="Titel"
        [(ngModel)]="selectedTitleOption"
        [compareWith]="compareOptions"
        (selectionChange)="selectedTitleOptionChanged()"
      >
        <mat-option *ngFor="let option of TITLE_OPTIONS" [value]="option">{{
          option.label
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div
    *ngIf="showOtherSidePicker || leftRightBoard"
    class="side-label left-label"
  >
    {{ label }}
  </div>
  <div
    *ngIf="selectedTitleOption?.id === OTHER_TITLE_ID"
    class="other-value-input top-margin"
  >
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="Gewenste titel"
        [(ngModel)]="ipBoardPart.otherTitle"
        (ngModelChange)="otherTitleChanged()"
      />
    </mat-form-field>
  </div>
</div>
<div
  *ngIf="showOtherSidePicker"
  class="association-picker less-form-field-padding"
>
  <mat-form-field appearance="outline">
    <mat-select
      matInput
      placeholder="Titel"
      [(ngModel)]="selectedOtherSideTitleOption"
      [compareWith]="compareOptions"
      (selectionChange)="selectedOtherSideTitleOptionChanged()"
    >
      <mat-option *ngFor="let option of TITLE_OPTIONS" [value]="option">{{
        option.label
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <div *ngIf="showOtherSidePicker" class="side-label">
    Rechts
  </div>
  <div
    *ngIf="selectedOtherSideTitleOption?.id === OTHER_TITLE_ID"
    class="other-value-input"
  >
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="Gewenste titel"
        [(ngModel)]="ipBoardPart.otherSideOtherTitle"
        (ngModelChange)="otherSideOtherTitleChanged()"
      />
    </mat-form-field>
  </div>
</div>
<div
  class="left-fifteen-space"
  *ngIf="
    ipBoardPart.boardType?.ordinal === BOARD_TYPE_CHOICES.V.ordinal &&
    !leftRightBoard
  "
>
  <mat-checkbox
    [(ngModel)]="showOtherSidePicker"
    (ngModelChange)="showOtherSidePickerChanged()"
    ><span class="smaller-text"
      >Links/Rechts bord afzonderlijk v/e titel voorzien</span
    ></mat-checkbox
  >
</div>
